import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-alert-popup',
  templateUrl: './alert-popup.component.html',
  styleUrls: ['./alert-popup.component.scss'],
})
export class AlertPopupComponent implements OnInit, AfterViewInit {

  showHeader = true;
  showBody   = true;
  showFooter = true;

  @ViewChild('headerContentDiv', {read: ElementRef, static: false}) headerContentDivEleRef: ElementRef;
  @ViewChild('bodyContentDiv', {read: ElementRef, static: false}) bodyContentDivEleRef: ElementRef;
  @ViewChild('footerContentDiv', {read: ElementRef, static: false}) footerContentDivEleRef: ElementRef;

  @Input() onOKCallback: Function = null;
  @Input() includeFooter = true;

  constructor() { }

  ngOnInit()
  {
  }

  ngAfterViewInit()
  {
    setTimeout(() => {
      if ((this.headerContentDivEleRef) && (this.headerContentDivEleRef.nativeElement.children.length > 0))
      {
        this.showHeader = true;
      }
      else
      {
        this.showHeader = false;
      }

      if ((this.bodyContentDivEleRef) && (this.bodyContentDivEleRef.nativeElement.children.length > 0))
      {
        this.showBody = true;
      }
      else
      {
        this.showBody = false;
      }

      if ((this.footerContentDivEleRef) && (this.footerContentDivEleRef.nativeElement.children.length > 0))
      {
        this.showFooter = true;
      }
      else
      {
        this.showFooter = false;
      }
    }, 0);
  }

  shouldShowHeader(): boolean
  {
    return this.showHeader;
  }

  shouldShowBody(): boolean
  {
    return this.showBody;
  }

  shouldShowFooter(): boolean
  {
    return this.showFooter;
  }

  onOkBtnAction()
  {
    if (this.onOKCallback)
    {
      this.onOKCallback();
    }
  }
}
